import React from "react";
interface MapProps {
  centerLatitude: number;
  centerLongitude: number;
  zoom: number;
  className: string;
}

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const ZMap: React.FC<MapProps> = ({
  centerLatitude,
  centerLongitude,
  zoom,
  className,
}) => {
  return (
    <iframe
      title="google-maps-parnter-location"
      width="600"
      height="450"
      loading="lazy"
      className={className}
      src={`https://www.google.com/maps/embed/v1/place?q=${centerLatitude},${centerLongitude}&zoom=${zoom}&key=${GOOGLE_MAPS_API_KEY}`}
    ></iframe>
  );
};

export default ZMap;
